export default "/images/framework/Winner.efd703b1.svg?efd703b1";